import { Component, OnInit, Input } from '@angular/core';
import { ResolutionAsignModalService } from './resolution-asign-modal.service';
import { Stock } from 'src/app/shared/models/stock.model';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { Resolution } from 'src/app/shared/models/resolution.model';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-resolution-asign-modal',
  templateUrl: './resolution-asign-modal.component.html',
  styleUrls: ['./resolution-asign-modal.component.scss']
})
export class ResolutionAsignModalComponent implements OnInit {

  @Input() currentStockId: number;
  @Input() currentPurposeId: number;

  resolutionForm: FormGroup;
  stockList: Stock[];
  purposeList: Purpose[];
  resolutionList: Resolution[];

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private resolutionAsignService: ResolutionAsignModalService,
              private toastr: ToastrService) { }

  /**
   * 
   */
  ngOnInit() {
    this.resolutionForm = this.formBuilder.group({
      stock_id     : ['', Validators.required],
      purpose_id   : ['', Validators.required],
      resolution_id: ['', Validators.required]
    });

    Promise.all([
      this.resolutionAsignService.getAllStocks(),
      this.resolutionAsignService.getAllPurposes()
    ]).then((result: any) => {
      this.stockList   = result[0] as Stock[];
      this.purposeList = result[1] as Purpose[];
      
      if (this.currentStockId && this.currentPurposeId) {
        this.resolutionForm.patchValue({
          stock_id  : this.currentStockId,
          purpose_id: this.currentPurposeId
        });
        this.getResolutions();
      }
    }).catch((error) => {
      console.error(error.message);
    });
  }

  /**
   * 
   */
  getResolutions() {
    const stockId   = this.resolutionForm.get('stock_id').value;
    const purposeId = this.resolutionForm.get('purpose_id').value;

    if (stockId && purposeId) {
      this.resolutionAsignService.getAllResolutions(stockId, purposeId).subscribe((response:Resolution[]) => {
        this.resolutionList = response;
        if (this.resolutionList.length === 0) {
          this.toastr.info('No se encontraron resoluciones para asignar, posiblemente ya esten todas asignadas a este propósito.');
        }
      }, (error) => {
  
      });
    }
  }

  /**
   * 
   */
  onStockChange() {
    this.getResolutions();
  }

  /**
   * 
   */
  onPurposeChange() {
    this.getResolutions();
  }

  /**
   * 
   */
  close() {
    this.activeModal.close(
      this.resolutionForm.value
    );
  }
}
